import { t, Trans } from '@lingui/macro';
import React, { MouseEventHandler } from 'react';
import {
  isAddressFullViewSwitchVisible,
  PersonModel
} from '../../../../selectors/addressUnmodeled';
import { createStructuredSelector } from 'reselect';
import { connect } from 'dva';

interface StateProps {
  isVisible: boolean;
}

interface OwnProps {
  model: PersonModel;
  isExpandedView: boolean;
  onClick: MouseEventHandler;
}

type Props = OwnProps & StateProps;

function AddressFullViewSwitch(props: Props): JSX.Element | null {
  if (!props.isVisible) return null;
  return (
    <div className="PguFormGrid__row">
      <button className="mos-link" onClick={props.onClick}>
        <Trans
          id={
            props.isExpandedView
              ? t`Скрыть полный адрес`
              : t`Показать полный адрес`
          }
        />
      </button>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  isVisible: isAddressFullViewSwitchVisible
});

export default connect(mapStateToProps)(AddressFullViewSwitch);
